interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
        <i className="ri-bookmark-3-line" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      ) : null}
    </div>
  );
}